import { HashRouter, Routes, Route } from "react-router-dom";
import Navigation from "./components/Navigation/Navigation.js";
import Home from "./components/Home/Home.js";
import About from "./components/About/About.js";
import Services from "./components/Services/Services.js";
import Projects from "./components/Projects/Projects.js";
import Contact from "./components/Contact/Contact.js";
import Quote from "./components/Quote/Quote.js";
import ConsultationPopup from "./components/ConsultationPopup/ConsultationPopup.js";
import Testimonials from "./components/Testimonals/Testimonals.js";
import Login from "./components/Login/Login.js";
import Dashboard from "./components/Dashboard/Dashboard.js";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute.js";
import DashHome from "./components/Dashboard/DashHome.js";
import Clients from "./components/Dashboard/Clients.js";
import Materials from "./components/Dashboard/Materials.js";
import Invoice from "./components/Dashboard/Invoice.js";
import Estimation1 from "./components/Dashboard/Estimation1.js";
import Settings from "./components/Dashboard/Settings.js";
import Payments from "./components/Dashboard/Payments.js";
import Notes from "./components/Dashboard/Notes.js";
import "./App.css";

function MainPage() {
  return (
    <div className="site-shell">
      <Navigation />

      <main>
        <ConsultationPopup />
        <Home />
        <About />
        <Services />
        <Projects />
        <Contact />
        <Testimonials />
      </main>
      <footer className="site-footer">
        <p>&copy; 2025 Sarrathi Constructions. All rights reserved.</p>
      </footer>
    </div>
  );
}

function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path="/quote" element={<Quote />} />
        <Route path="/admin" element={<Login />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        >
          <Route index element={<DashHome />} />
          <Route path="clients" element={<Clients />} />
          <Route path="materials" element={<Materials />} />
          <Route path="invoice" element={<Invoice />} />
          <Route path="estimation" element={<Estimation1 />} />
          <Route path="settings" element={<Settings />} />
          <Route path="payments" element={<Payments />} />
          <Route path="notes" element={<Notes />} />
        </Route>
      </Routes>
    </HashRouter>
  );
}

export default App;
